/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from "react";
import { smoothScroll } from "../../utils/scrollbarUtil";
import Content from "../content/Content";
import { cleanJoin } from "../../utils/stringUtil";
import { isMobile, isTouch } from "../../utils/screenUtil";

import Row from "../columns/Row";
import Column from "../columns/Column";
import InputField from "../../common/input/InputField";

function Tabs({
  prefix = "t",
  scrollToSection = true,
  activeTab,
  setActiveTab,
  tabsClassName = "",
  scrollableContentClassName = "",
  scrollableContentHeight,
  isScrollable,
  children,
  setCategoryQuery,
  categoryQuery,
  filter,
  isFilter,
}) {
  useEffect(() => {
    if (scrollToSection) {
      smoothScroll(`#${prefix}${activeTab}`);
    }
  }, [activeTab, prefix, scrollToSection]);
  const [isSticky, setIsSticky] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    const header = headerRef?.current;
    const observer = new IntersectionObserver(
      ([e]) => {
        setIsSticky(e.isIntersecting);
      },
      { threshold: [0.1, 1] }
    );

    if (header) {
      observer.observe(header);
    }

    return () => {
      observer.unobserve(header);
    };
  }, [headerRef]);

  const Filter = filter;

  return (
    <div>
      <div
        className={cleanJoin(
          "tabs is-medium is-centered is-fullwidth",
          isMobile() ? "scrollbar-no-width" : "",
          tabsClassName
        )}
        data-testid="tabsNav"
        id="tabsNav"
        ref={headerRef}
        style={
          isSticky === false
            ? {
                position: "sticky",
                width: "100%",
              }
            : { top: 0 }
        }
      >
        <ul className="mt-0 ml-0 p-1">
          {children.map((child, index) => {
            return (
              <li
                key={prefix + index}
                className={
                  child.props.categoryId >= 0
                    ? child.props.categoryId === activeTab
                      ? "is-active"
                      : ""
                    : +index === +activeTab
                    ? "is-active"
                    : ""
                }
              >
                <a
                  onClick={() => {
                    isFilter && setCategoryQuery("");

                    if (child.props.categoryId >= 0) setActiveTab(child.props.categoryId);
                    else setActiveTab(index);
                  }}
                >
                  {child.props.label}
                </a>
              </li>
            );
          })}
        </ul>
      </div>

      <Row className="mt-0 mb-0">
        {isFilter && <Filter />}
        <Column>
          <Content
            className={scrollableContentClassName}
            height={scrollableContentHeight}
            isScrollable={isScrollable}
          >
            {isFilter && (
              <div className="mt-2 is-flex is-flex-direction-row-reverse">
                <div className="field control" style={{ width: isTouch() ? "100%" : "25%" }}>
                  <InputField
                    placeholder={"Traži..."}
                    onChange={(e) => setCategoryQuery(e.currentTarget.value)}
                    value={categoryQuery}
                  />
                </div>
              </div>
            )}
            {children.map((child, index) => (
              <section
                key={prefix + index}
                id={prefix + (child.props.categoryId >= 0 ? child.props.categoryId : index)}
                className={cleanJoin(
                  "section  ",
                  child.props.className,
                  scrollToSection
                    ? ""
                    : child.props.categoryId >= 0
                    ? activeTab === child.props.categoryId
                      ? ""
                      : "is-hidden"
                    : activeTab === index
                    ? ""
                    : "is-hidden"
                )}
              >
                {child}
              </section>
            ))}
          </Content>
        </Column>
      </Row>
    </div>
  );
}

export default Tabs;
